import { z } from 'zod'

/**
 * 帳號 - 新增/更新 Response Schema
 */
export const upsertAccountResponseSchema = z.object({
  /** 帳號 */
  accountNo: z.string(),
  /** 真實姓名 */
  realName: z.string()
})

/**
 * 帳號 - 新增/更新 Response
 */
export interface UpsertAccountResponse
  extends z.infer<typeof upsertAccountResponseSchema> {}
